import { Controller } from "@hotwired/stimulus"
import Honeybadger from "@honeybadger-io/js"

export default class extends Controller {
  static values = { env: String, userId: String }

  initialize() {
    Honeybadger.configure({
      apiKey: 'hbp_n1p07svZh1qSJIm3XjjHtpiOlFZ7ca3SKFoA',
      environment: this.envValue
    });

    Honeybadger.setContext({
      user_id: this.userIdValue,
    });
  }
}
